import styled from 'styled-components';

export default styled.div`
  position: relative;
  width: 100%;
  height: 192px;
  margin-bottom: 10px;
  overflow: hidden;
  pointer-events: none;

  img {
    position: absolute;
    left: 50%;
    top: 0;
    width: 192px;
    height: 192px;
    object-fit: contain;
    transform: translateX(-50%);
  }
`;
